import script from "./cockpit.vue?vue&type=script&setup=true&lang=ts"
export * from "./cockpit.vue?vue&type=script&setup=true&lang=ts"

import "./cockpit.vue?vue&type=style&index=0&id=a602331c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a602331c"]])

export default __exports__